var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-modal", { attrs: { id: "busModal", "hide-footer": true } }, [
    _c(
      "div",
      { attrs: { id: "busForm" } },
      [
        _c(
          "div",
          { staticClass: "formTitle" },
          [
            _c("svg-image", { attrs: { image: "iconBus" } }),
            _c("h5", [_vm._v(_vm._s(_vm.$t("shuttle.modal.head")))])
          ],
          1
        ),
        _c("div", { staticClass: "groupLabel" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("shuttle.modal.lpoint")))])
        ]),
        _c(
          "b-row",
          [
            _c("b-col", [
              _c("div", {
                staticClass: "point",
                domProps: { innerHTML: _vm._s(_vm.$t("shuttle.modal.p1")) }
              })
            ]),
            _c("b-col", [
              _c("div", {
                staticClass: "point",
                domProps: { innerHTML: _vm._s(_vm.$t("shuttle.modal.p2")) }
              })
            ])
          ],
          1
        ),
        _c(
          "b-row",
          [
            _c("b-col", [
              _c("div", {
                staticClass: "point",
                domProps: { innerHTML: _vm._s(_vm.$t("shuttle.modal.p3")) }
              })
            ]),
            _c("b-col", [
              _c("div", {
                staticClass: "point",
                domProps: { innerHTML: _vm._s(_vm.$t("shuttle.modal.p4")) }
              })
            ])
          ],
          1
        ),
        _c("div", { staticClass: "groupLabel" }, [
          _c("label", [_vm._v(_vm._s(_vm.$t("shuttle.modal.lform")))])
        ]),
        _c(
          "b-form",
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("shuttle.modal.fpoint"),
                  "label-for": "",
                  description: _vm.$t("shuttle.modal.fpointdesc")
                }
              },
              [
                _c(
                  "b-form-select",
                  [
                    _c("b-form-select-option", { attrs: { value: "JOG1" } }, [
                      _vm._v("Plaza Ambarrukmo Yogyakarta")
                    ]),
                    _c("b-form-select-option", { attrs: { value: "JOG2" } }, [
                      _vm._v("Abu Bakar Ali Parking Area")
                    ]),
                    _c("b-form-select-option", { attrs: { value: "JOG3" } }, [
                      _vm._v("Televisi Republik Indonesia Yogyakarta")
                    ]),
                    _c("b-form-select-option", { attrs: { value: "MGL1" } }, [
                      _vm._v("Armada Town Square Magelang")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "b-form-group",
              {
                attrs: {
                  id: "",
                  label: _vm.$t("shuttle.modal.freturn"),
                  "label-for": "",
                  description: _vm.$t("shuttle.modal.freturndesc")
                }
              },
              [
                _c(
                  "b-form-select",
                  [
                    _c("b-form-select-option", { attrs: { value: "R1" } }, [
                      _vm._v("11.00 WIB (GMT+7)")
                    ]),
                    _c("b-form-select-option", { attrs: { value: "R2" } }, [
                      _vm._v("12.00 WIB (GMT+7)")
                    ]),
                    _c("b-form-select-option", { attrs: { value: "R3" } }, [
                      _vm._v("13.00 WIB (GMT+7)")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "clearfix" },
              [
                _c(
                  "b-button",
                  {
                    attrs: {
                      block: "",
                      type: "submit",
                      variant: "primary",
                      size: "lg"
                    }
                  },
                  [
                    _c("b-spinner", { attrs: { small: "", type: "grow" } }),
                    _vm._v(" " + _vm._s(_vm.$t("shuttle.modal.fbtn")))
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BusModal.vue?vue&type=template&id=47c82486&
// module id = 876
// module chunks = 0